require('/opt/odin/app/frontend/components/unlimited_access/index.module.scss');module.exports = "../../app/cells/components/unlimited_access/show.erb";